import script from "./DueDiligenceList.vue?vue&type=script&setup=true&lang=js"
export * from "./DueDiligenceList.vue?vue&type=script&setup=true&lang=js"

import "./DueDiligenceList.vue?vue&type=style&index=0&id=c3dbe420&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c3dbe420"]])

export default __exports__